module.exports = __webpack_public_path__ + "img/mazolegal.b2fe5e2f.png";